<div *ngIf="travelMixListFiltered; else notYetLoaded">
    <div style="width: 100%;padding-top: 15px;padding-bottom: 15px;">
        <div style="background-color: rgb(232, 109, 31);color: whitesmoke;text-align: center;">
            <h3>{{travelmixSelectionTitel}}</h3>
        </div>
        <div style="padding-top:15px;padding-bottom:15px;">
            <div style="display: inline-flex;align-content: center;flex-wrap: wrap;align-items: center;width: 100%;">
                <label style="font-size: 1.17em;font-weight: bold;padding-right:15px;">{{travelmixFilterTitel}}
                    <mat-icon style="font-size: 1.17em;">filter_list</mat-icon></label>
                <mat-form-field style="padding-right:15px;" class="w-350">
                    <mat-label>Choose a connection filter option</mat-label>
                    <mat-select [(ngModel)]="selectedConnections" multiple (selectionChange)="connectionFilterChange()"
                        [disabled]="travelMixList == undefined">
                        <mat-option class="select-without-checkbox" *ngFor="let connection of connectionsSource" [value]="connection.Name">
                            {{connection.Name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field style="padding-right:15px;" class="w-350">
                    <mat-label>Choose a season filter option</mat-label>
                    <mat-select [(ngModel)]="selectedSeasons" multiple (selectionChange)="saisonFilterChange()"
                        [disabled]="travelMixList == undefined">
                        <mat-option class="select-without-checkbox" *ngFor="let season of seasonsSource" [value]="season.Value">
                            {{season.Name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <div style="display: flex;justify-content: space-between;">
            <mat-chip-list aria-label="Travelmix selection" style="width: 100%;">
                <mat-chip *ngFor="let travelOption of travelMixListFiltered" class="custom-chip"
                    [ngClass]="selectedTravelmixesContains(travelOption) ? 'selected' : 'not-selected'"
                    (click)="processTravelOption(travelOption)">
                    <span>{{travelOption.name}} <mat-icon style="padding-left: 10px;font-size: 22px;"
                            *ngIf="selectedTravelmixesContains(travelOption)">done</mat-icon></span>

                </mat-chip>
                <p
                    *ngIf="travelMixListFiltered === undefined || travelMixListFiltered && travelMixListFiltered.length === 0">
                    There are no travel mixes available in the current selection of transport mode in tab advanced
                    settings.
                    Try to Change the transport mode type.</p>
            </mat-chip-list>
        </div>
    </div>
    
</div>
<ng-template #notYetLoaded>
    <p>Please select a project first to see this content</p>
</ng-template>